import { render, staticRenderFns } from "./LoadingScreen.vue?vue&type=template&id=2e6882ba&"
import script from "./LoadingScreen.vue?vue&type=script&lang=ts&"
export * from "./LoadingScreen.vue?vue&type=script&lang=ts&"
import style0 from "./LoadingScreen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports